import React, { useEffect, useRef, useState } from "react";
import logo from "../../assets/logo/logonew.png";
import { Collapse } from "flowbite";

const Navbar = () => {
  const target = useRef(null);
  const trigger = useRef(null);
  const [bool, setbool] = useState(false);
  const [blogsOpen, setBlogsOpen] = useState(false);
  //Mobile Navbar func
  const mobile = () => {
    const hammenu = target.current;
    const nav = trigger.current;

    const navoptions = {
      onCollapse: () => { },
      onExpand: () => { },
      onToggle: () => { },
    };
    const mobnav = new Collapse(hammenu, nav, navoptions);
    mobnav.expand();
    mobnav.collapse();

    if (bool === true) {
      mobnav.collapse();
    }
  };

  useEffect(() => {
    mobile();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <nav className="bg-charcoal/95 backdrop-blur-md fixed w-full z-50 px-5 py-3 lg:px-12 lg:py-2 top-0 left-0 border-b border-linen/10 shadow-lg transition-all duration-500">
        <div className="max-w-[1400px] m-auto flex flex-wrap items-center justify-between">
          
          <div className="w-full flex justify-between lg:w-auto items-center py-1">
            {/* Logo Section */}
            <a href="/" className="flex items-center group">
              <div className="relative overflow-hidden mr-4 h-10 w-auto min-w-[100px] lg:h-14 lg:min-w-[140px]">
                 <img src={logo} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" alt="Weaving Hands Logo" />
              </div>
              {/* <span className="self-center text-linen font-serif tracking-[0.12em] text-lg lg:text-2xl uppercase font-medium">
                Weaving Hands
              </span> */}
            </a>

            {/* Mobile: Phone icon + Hamburger */}
            <div className="flex items-center gap-3 lg:hidden">
              <a href="tel:+919444161667" className="flex items-center justify-center w-9 h-9 rounded-full border border-brass/60 text-brass hover:bg-brass hover:text-charcoal transition-colors">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
              </a>
              <button
                data-collapse-toggle="navbar-sticky"
                id="hammenu"
                ref={trigger}
                type="button"
                className="inline-flex items-center p-2 text-linen rounded-lg hover:bg-white/5 focus:outline-none"
                aria-controls="navbar-sticky"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg className="w-6 h-6" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              </button>
            </div>
          </div>

          {/* Desktop + Mobile Dropdown Menu */}
          <div
            className="items-center justify-between hidden w-full lg:flex lg:w-auto lg:mt-0"
            id="navbar-sticky"
            ref={target}
          >
            {/* Mobile menu panel */}
            <div className="flex flex-col lg:flex-row lg:items-center gap-0 lg:gap-10 w-full lg:w-auto border-t border-linen/10 lg:border-0 mt-2 lg:mt-0 pb-4 lg:pb-0">
              {[
                { href: "/", label: "Home" },
                { href: "/about", label: "Our Story" },
                { href: "/furnitures", label: "Collections" },
                { 
                  label: "Blogs", 
                  isDropdown: true,
                  subLinks: [
                    { label: "Manufacture Process", href: "https://weavinghandblog.blogspot.com/2026/02/furniture-manufacturing-in-chennai-how.html", external: true },
                    { label: "Traditional Carpentry", href: "https://weavinghandblog.blogspot.com/2026/01/traditional-carpentry-work-in-furniture.html", external: true },
                    { label: "Cane Weaving", href: "https://weavinghandblog.blogspot.com/2026/01/cane-weaving-in-handcrafted-furniture.html", external: true }
                  ]
                },
                { href: "/contact", label: "Contact" }
              ].map((link) => (
                link.isDropdown ? (
                  <div key={link.label} className="relative group w-full lg:w-fit py-3 lg:py-0 px-0 border-b border-linen/5 lg:border-0">
                    <button 
                      onClick={() => setBlogsOpen(!blogsOpen)}
                      className="flex items-center justify-between w-full lg:w-fit text-linen/90 uppercase tracking-[0.12em] text-sm font-medium hover:text-brass transition-colors group"
                    >
                      {link.label}
                      <svg className={`w-4 h-4 ml-1.5 transition-transform duration-300 ${blogsOpen ? 'rotate-180' : ''} lg:group-hover:rotate-180`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                      </svg>
                    </button>
                    
                    {/* Dropdown Menu */}
                    <div className={`
                      lg:absolute lg:top-full lg:left-0 lg:mt-2 w-full lg:w-64 bg-charcoal border border-brass/20 rounded-md shadow-2xl 
                      transition-all duration-300 z-[60] overflow-hidden
                      ${blogsOpen ? 'max-h-[500px] opacity-100 visible mt-4 lg:mt-2' : 'max-h-0 lg:max-h-none opacity-0 lg:opacity-0 invisible lg:invisible'} 
                      lg:group-hover:opacity-100 lg:group-hover:visible lg:group-hover:translate-y-0 lg:translate-y-2
                    `}>
                      <div className="py-2 flex flex-col">
                        {link.subLinks.map((sub) => (
                          <a
                            key={sub.label}
                            href={sub.href}
                            target={sub.external ? "_blank" : "_self"}
                            rel={sub.external ? "noopener noreferrer" : ""}
                            className="px-4 py-3 text-linen/80 text-xs uppercase tracking-widest hover:bg-brass hover:text-charcoal transition-all duration-300 border-b border-linen/5 last:border-0"
                          >
                            {sub.label}
                          </a>
                        ))}
                      </div>
                    </div>
                    <span className="hidden lg:block absolute -bottom-1 left-0 w-0 h-[1px] bg-brass transition-all duration-300 group-hover:w-full"></span>
                  </div>
                ) : (
                  <a
                    key={link.href}
                    href={link.href}
                    className="text-linen/90 uppercase tracking-[0.12em] text-sm font-medium hover:text-brass transition-colors relative group w-full lg:w-fit py-3 lg:py-0 px-0 border-b border-linen/5 lg:border-0"
                  >
                    {link.label}
                    <span className="hidden lg:block absolute -bottom-1 left-0 w-0 h-[1px] bg-brass transition-all duration-300 group-hover:w-full"></span>
                  </a>
                )
              ))}
              
              <a
                href="tel:+919444161667"
                className="hidden lg:flex bg-brass text-charcoal shadow-md items-center rounded-md hover:bg-linen hover:text-charcoal transition-all duration-300 px-6 py-2.5 text-sm font-sans font-medium tracking-widest mt-0"
              >
                <svg className="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                +91 94441 61667
              </a>
            </div>
          </div>
          
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
